import APP_ICONS from "./icons"

const lecturesSubsiderOptions = [
    {
        icon: APP_ICONS.EXAMS_LIST,
        title: "Lectures",
        link: "/admin/lectures"
    },
    {
        icon: APP_ICONS.CATEGORIES_TAG,
        title: "Meetings",
        link: "/admin/lectures/meetings"
    }
]

export default lecturesSubsiderOptions